import { useMemo } from "react";

import useApi from "../../../../../hooks/api";

import { buildVacationRequestsRepository } from "../infrastructure";

import { createUseVacationRequests } from "./useVacationRequests";
import { createUseRequestDetail } from "./useRequestDetail";
import { createUseRequestFiles } from "./useRequestFiles";

type UseVacationRequestsT = {
  colaboraInstanceId: string;
  enabled?: boolean;
  startDate?: string | null;
  endDate?: string | null;
  periodTypeId?: string | null;
};

export const useVacationRequests = ({
  colaboraInstanceId,
  enabled = true,
  startDate = null,
  endDate = null,
  periodTypeId = null,
}: UseVacationRequestsT) => {
  const { genericApiCall } = useApi();

  const vacationRequestsRepository = useMemo(
    () => buildVacationRequestsRepository({ apiCaller: genericApiCall }),
    [genericApiCall],
  );

  const useVacationRequestsQuery = useMemo(
    () => createUseVacationRequests({ vacationRequestsRepository }),
    [vacationRequestsRepository],
  );

  return useVacationRequestsQuery({
    colaboraInstanceId,
    enabled,
    startDate,
    endDate,
    periodTypeId,
  });
};

type UseRequestDetailT = {
  requestId: string;
  colaboraInstanceId: string;
};

export const useRequestDetail = ({
  requestId,
  colaboraInstanceId,
}: UseRequestDetailT) => {
  const { genericApiCall } = useApi();

  const vacationRequestsRepository = useMemo(
    () => buildVacationRequestsRepository({ apiCaller: genericApiCall }),
    [genericApiCall],
  );

  const useRequestDetailQuery = useMemo(
    () => createUseRequestDetail({ vacationRequestsRepository }),
    [vacationRequestsRepository],
  );

  return useRequestDetailQuery({ requestId, colaboraInstanceId });
};

type UseRequestFilesT = {
  requestId: string;
  colaboraInstanceId: string;
};

export const useRequestFiles = ({
  requestId,
  colaboraInstanceId,
}: UseRequestFilesT) => {
  const { genericApiCall } = useApi();

  const vacationRequestsRepository = useMemo(
    () => buildVacationRequestsRepository({ apiCaller: genericApiCall }),
    [genericApiCall],
  );

  const useRequestFilesQuery = useMemo(
    () => createUseRequestFiles({ vacationRequestsRepository }),
    [vacationRequestsRepository],
  );

  return useRequestFilesQuery({ requestId, colaboraInstanceId });
};
